import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { LicenseInfo } from '@wdx/clmi/clmi-swagger-gen';
import { Observable, tap } from 'rxjs';
import * as licenseActions from './license.actions';
import { State } from './license.reducer';
import * as licenseSelectors from './license.selectors';

@Injectable({
    providedIn: 'root',
})
export class LicenseFacadeService {
    store$ = inject(Store<State>);

    getLicense$(): Observable<LicenseInfo | undefined> {
        return this.store$
            .select(licenseSelectors.getLicense())
            .pipe(tap((license) => !license && this.loadLicense()));
    }

    getLicenseIsLoading$(): Observable<boolean | undefined> {
        return this.store$.select(licenseSelectors.getLicenseIsLoading());
    }

    getLicenseHasError$(): Observable<boolean | undefined> {
        return this.store$.select(licenseSelectors.getLicenseHasLoadingError());
    }

    loadLicense(): void {
        this.store$.dispatch(licenseActions.getLicense());
    }
}
